/**
 * @readonly
 * @enum {string}
 */
export const Track = Object.freeze({
    ACCELERATION_RANGE: 'accelerationRange',
    COUNTRY: 'country',
    COURSE: 'course',
    CUMULATED_FUEL_CONSUMPTION: 'cumulatedFuelConsumption',
    ENERGY_CONSUMPTION: 'energyConsumption',
    ENGINE_SPEED: 'engineSpeed',
    ENGINE_STATE: 'engineState',
    FUEL_USAGE: 'fuelUsage',
    GEAR: 'gear',
    GPS_TIME: 'gpsTime',
    GREEN_SPEED: 'greenSpeed',
    IN_CITY: 'inCity',
    IQR_AVERAGE_SPEED: 'iqrAverageSpeed',
    IQR_FREEFLOW_SPEED: 'iqrFreeflowSpeed',
    ODOMETER: 'odometer',
    ORIGIN: 'origin',
    PLMN: 'plmn',
    POSITION: 'position',
    RECEIVE_TIME: 'receiveTime',
    ROAD_SPEED_LIMIT: 'roadSpeedLimit',
    ROAD_TYPE: 'roadType',
    SPEED: 'speed',
    SPEED_RANGE: 'speedRange',
    STATE: 'state'
})
